<div class="main">


  <div class="app">
    <div class="column" style="background-color:rgb(156, 41, 250); color:rgb(255, 255, 255)">
      <app-calculator></app-calculator>
    </div>
    <div class="column" style="background-color:rgb(151, 9, 194); color:rgb(255, 255, 255)">
      <app-triangulator></app-triangulator>
    </div>
    <div class="column" style="background-color:rgb(98, 0, 155);color:rgb(255, 255, 255)">
      <app-misc></app-misc>
    </div>
  </div>

  <div class="hints">

    <h3>
      Инструкция для маленьких
    </h3>
    <ol>
      <li>Откройте панель телепада отверткой, используйте мультитул, закройте панель, используйте мультитул на консоль.
      </li>
      <li>Вставьте все блюспейс кристалы в консоль.</li>
      <li>Выставьте Отклонение(Bearing) на 0, Подъем(Elevation) на 45, Силу(Power) на 25, Сектор(Sector) на 5.</li>
      <li>Откройте воронку.</li>
      <li>Возьмите два GPS, выставьте теги "GPS1" и "GPS2".</li>
      <li>Перетащите pull'ом GPS1 в воронку.</li>
      <li>Закройте воронку, смените Подъем на 50, снова откройте.</li>
      <li>перетащите GPS2 в воронку.</li>
      <li>Закрыть воронку.</li>
      <li>Ввести координаты GPS1 и GPS2 в поля (X1,Y1), (X2,Y2).</li>
      <li>Ввести позицию телепада (Если вы на Исходе можете нажать специальную кнопку).</li>
      <li>Вычислить ошибки.</li>
      <li>Ввести нужные координаты, нажать "вычислить данные", ввести их в консоль, бум и готово!</li>
    </ol>


    <h3>Особенности калькулятора</h3>

    <ul>
      <li>Рядом с полями ввода координат есть кнопки в виде точек, нажмите на них и можете вставлять координаты в виде
        Telesciece Lab(145,160,2) или Unknown shuttle x=150, y=12, z=unknown
        <br> Выделяйте строки в GPS или бумаге РД, копируйте и вставляйте.
      </li>
      <li>Если ошибки подсвечены красным, значит вы ошиблись в измерениях</li>
      <li>Если ошибки подсвечены красным и вместо чисел NaN, значит вы забыли ввести координаты телепада или одной из
        воронок</li>
      <li>Слепой прыжок, загрузит в поля ошибок средние значения, это может помочь если у вас нету времени на калибровку
      </li>
    </ul>

    <h4><a href="https://forum.taucetistation.org/t/telenauka-dlya-malenkih-i-ne-ochen/20515/15">Путеводитель по
        дереликтам и предложения для улучшения</a></h4>
  </div>


</div>
<app-embeded-map></app-embeded-map>